<sz-segmented [options]="options()" [value]="value()" [mono]="true" (valueChange)="valueChange.emit($event)" />
